<template>
	<div class="overTime">
		<span>{{overtimeNum}}s</span>
	</div>
</template>

<script>
import { overTime,overtimeStatus } from '../../../../static/js/utils/utility.js'
export default {
	props:['callBack'],
	data(){
		return {
			overtimeNum:0,
		}
	},
	created(){
		
	},
	mounted(){
		this.overtimeNum = this.$store.state.overTime
		overTime(this.callBack)
	},
	methods:{
		
	},
	destroyed(){
		console.log('超时destroy')
		clearTimeout(overtimeStatus)
	},
	watch:{
		'$store.state.overTime': function(newVal){
			this.overtimeNum = newVal
		},
	}
}
</script>

<style lang="less">
.overTime{
	position: fixed;
	left: 0.2rem;
	top: 0.2rem;
	z-index: 10;
	font-size: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/assets/overTime.vue